<template>
  <fa-icon icon="tachometer-alt" />
</template>
